<template lang="pug">
  multiselect(
    :value="value"
    :options="MSICList"
    placeholder="Type to search"
    label="Desc_en"
    track-by="Desc_en"
    name="code"
    @input="onInput"
    :disabled="disabled"
    :loading="MSIC_loading"
    :internalSearch="false"
    @search-change="loadMSIC"
  )
    template(slot="option" slot-scope="props")
      span.block {{ props.option.code }} -  {{ props.option.Desc_en }}
</template>

<script>
import jsonData from './e-invoice/MSICSubCategoryCodes.json';
import _ from 'lodash';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            MSICList: [],
            MSIC_loading: false,
        };
    },
    mounted() {
        this.loadMSIC();
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        },
        loadMSIC: _.debounce(function(query) {
            this.MSIC_loading = true;

            if (query) {
                this.MSICList = jsonData.filter(
                    item =>
                        item.Desc_en.toLowerCase().includes(
                            query.toLowerCase(),
                        ) ||
                        item.code.toLowerCase().includes(query.toLowerCase()),
                );
            } else {
                this.MSICList = jsonData;
            }

            this.MSIC_loading = false;
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/eMSICSelector.vue